// função para auxiliar no set de cookies
export default function setCookies(name: string, value: string, days?: number) {
  const isLocalHost =
    process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'local'
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
    value,
  )}; path=/`

  if (days) {
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
    cookieString += `; expires=${expires.toUTCString()}`
  }

  if (!isLocalHost) {
    cookieString += '; Secure'
  }

  document.cookie = cookieString
}
